import { useCachedTags, useTellescopeMutation } from "@tellescope/tanstack-query";
import { useCallback } from "react";
import { TagsCell } from "./TagsCell";

interface TicketTagsCellProps {
  ticketId: string;
  tags: string[];
}

export const TicketTagsCell = ({ ticketId, tags }: TicketTagsCellProps) => {
  const { data: tagOptions } = useCachedTags({ model: "tickets" });
  const updateTicketMutation = useTellescopeMutation({
    model: "tickets",
    method: "updateOne",
  });

  const onAddTag = useCallback(
    (tag: string) => {
      updateTicketMutation.mutateAsync({
        id: ticketId,
        tags: [...(tags ?? []), tag],
        _options: { replaceObjectFields: true },
      });
    },
    [ticketId, tags, updateTicketMutation]
  );

  const onRemoveTag = useCallback(
    (tag: string) => {
      updateTicketMutation.mutateAsync({
        id: ticketId,
        tags: (tags ?? []).filter((existingTag) => existingTag !== tag),
        _options: { replaceObjectFields: true },
      });
    },
    [ticketId, tags, updateTicketMutation]
  );

  return <TagsCell tags={tags ?? []} availableOptions={tagOptions} onAddTag={onAddTag} onRemoveTag={onRemoveTag} />;
};
